import { render, staticRenderFns } from "./ImportTemplateFromTm.vue?vue&type=template&id=9f55288c"
import script from "./ImportTemplateFromTm.vue?vue&type=script&lang=js"
export * from "./ImportTemplateFromTm.vue?vue&type=script&lang=js"
import style0 from "./ImportTemplateFromTm.vue?vue&type=style&index=0&id=9f55288c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports